import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type PopupProps = {
  trigger: string; // id of the button
  children: React.ReactNode;
  timer?: number
};

type Position = {
  top: number;
  left: number;
};

const Popup: React.FC<PopupProps> = ({ trigger, children, timer=1000}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [position, setPosition] = useState<Position>({ top: 0, left: 0 });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const button = document.getElementById(trigger);

    if (!button) return;

    const handleClick = () => {
      const rect = button.getBoundingClientRect();
      console.log(rect);

      setPosition({
        top: rect.top, // top of button
        left: rect.left + rect.width / 2, // center of button
      });

      setVisible(true);
      setFading(false);

      const fadeTimer = setTimeout(() => {
        setFading(true);
      }, timer);

      const removeTimer = setTimeout(() => {
        setVisible(false);
        setFading(false);
      }, timer+300); // 300ms fade duration

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    };

    button.addEventListener("click", handleClick);

    return () => {
      button.removeEventListener("click", handleClick);
    };
  }, [trigger,timer]);

  if (!visible) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: "translate(-50%, -100%)",
        background: "#333",
        color: "#fff",
        padding: "8px 12px",
        borderRadius: "8px",
        fontSize: "14px",
        zIndex: 1000,
        whiteSpace: "nowrap",
        opacity: fading ? 0 : 1,
        transition: "opacity 0.3s ease",
      }}
    >
      {children}
    </div>,
    document.body,
  );
};

export default Popup;
